  const generateSrcset = (image, widths = []) => {
    const imageUrl = new URL(image["src"]);
    return widths.filter((width) => width <= image["width"]).map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    }).join(", ");
  }

  const createImageElement = (image, classes, sizes, productTitle) => {
    const previewImage = image["preview_image"];
    const newImage = new Image(previewImage["width"], previewImage["height"]);
    newImage.className = classes;
    newImage.alt = image["alt"] || productTitle;
    newImage.sizes = sizes;
    newImage.src = previewImage["src"];
    newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
    newImage.loading="lazy"
    return newImage;
  }

  // custom.images metafield URLs have no width/height/srcset info, so they render as a plain
  // <img> - matching how the Liquid custom_images branch renders the initial primary image.
  const createCustomImageElement = (imageUrl, classes, productTitle) => {
    const newImage = new Image();
    newImage.className = classes;
    newImage.alt = productTitle;
    newImage.loading = "lazy";
    newImage.src = imageUrl;
    return newImage;
  }

  // custom.images metafield entries don't get a matching secondary hover image (see
  // product-card.liquid), so a custom-image swap always does a full replace, never the
  // "promote secondary to primary" shortcut used for native Shopify media.
  const swapPrimaryImage = (newPrimaryImage, primaryImage, secondaryImage, allowPromoteSecondary) => {
    if (newPrimaryImage.src === primaryImage.src) return;

    let promoted = false;
    if (allowPromoteSecondary && secondaryImage) {
      const secondaryImagePathname = new URL(secondaryImage.src).pathname;
      const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

      if (secondaryImagePathname == newPrimaryImagePathname) {
        primaryImage.remove();
        secondaryImage.classList.remove('media--second');
        secondaryImage.classList.add('media--first');
        promoted = true;
      }
    }

    if (!promoted) {
      primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
      setTimeout(function () {
        primaryImage.replaceWith(newPrimaryImage);
        newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
        if (secondaryImage) {
          secondaryImage.remove();
        }
      }, 200);
    }
  }

  // custom.images (ERP, variant-scoped) must win over the native variant.featured_media here too,
  // same priority as the initial render - otherwise a swatch click on a product card reintroduces
  // exactly the stale/orphaned image bug (K-1309) that the initial-render fix addresses.
  const getCustomImagesByVariantId = (wrapper) => {
    const script = wrapper.querySelector('[type="application/json+variant-custom-images"]');
    const map = {};
    if (!script) return map;
    try {
      JSON.parse(script.textContent).forEach(entry => {
        map[entry.id] = entry.image;
      });
    } catch (e) {}
    return map;
  }

  // variant.featured_media can be a certification/norm seal image the ERP filed under the same
  // field as real photos (K-1733) - a swatch click must treat that the same as "no featured_media",
  // matching the server-side is-junk-image-url filtering applied to the initial render.
  const getJunkFeaturedMediaVariantIds = (wrapper) => {
    const script = wrapper.querySelector('[type="application/json+variant-junk-featured-media"]');
    if (!script) return new Set();
    try {
      return new Set(JSON.parse(script.textContent));
    } catch (e) {
      return new Set();
    }
  }

  const checkSwatches = () => {
    document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
      const customImagesByVariantId = getCustomImagesByVariantId(wrapper);
      const junkFeaturedMediaVariantIds = getJunkFeaturedMediaVariantIds(wrapper);
      const hasUsableFeaturedMedia = (item) => item.featured_media != null && !junkFeaturedMediaVariantIds.has(item.id);

      wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
        input.addEventListener('click', (event) => {
          const primaryImage = wrapper.querySelector(".media--first");
          const secondaryImage = wrapper.querySelector(".media--second");
          const handleProduct = wrapper.dataset.product;

          if (event.currentTarget.checked && primaryImage) {
            wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
              wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
            }

            const currentColor = event.currentTarget.value;

            jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
              const variant = product.variants.filter(item => item.options.includes(currentColor)
                && (hasUsableFeaturedMedia(item) || customImagesByVariantId[item.id] != null))[0];

              if (!variant) return;

              const customImageUrl = customImagesByVariantId[variant.id];

              if (customImageUrl) {
                const newPrimaryImage = createCustomImageElement(customImageUrl, primaryImage.className, product.title);
                swapPrimaryImage(newPrimaryImage, primaryImage, secondaryImage, false);
                return;
              }

              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
              swapPrimaryImage(newPrimaryImage, primaryImage, secondaryImage, true);
            });
          }
        })
      })
    })
  }

  function colorSwatches() {
    checkSwatches();

    document.addEventListener('shopify:section:load', function () {
      checkSwatches();
    });
  }

(function () {
  colorSwatches();
})()